import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-selector">
      <button
        className={i18n.language === 'fr' ? 'active' : ''}
        onClick={() => changeLanguage('fr')}
        title="Français"
      >
        🇫🇷
      </button>
      <button
        className={i18n.language === 'en' ? 'active' : ''}
        onClick={() => changeLanguage('en')}
        title="English"
      >
        🇬🇧
      </button>
    </div>
  );
};

export default LanguageSelector;
